import axios from "axios";
import Config from "../../Config";
const BASE_URL = Config.baseUrl;

class SubscriberService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
      },
    };
  }

  async getSubscriberStats() {
    try {
      const response = await axios.get(`${BASE_URL}/get_subscribers_stats`, {
        headers: this.getHeaders(),
      });
      return {
        status_code: response.data.data.status_code,
        stats: response.data.data.data.stats,
      };
    } catch (error) {
      return {
        status_code: error.response.data.data.status_code,
        reason: error.response.data.data.reason,
      };
    }
  }

  //* New method for server-side pagination with search
  async getSubscribersPaginated(
    page = 1,
    limit = 15,
    search = "",
    sortBy = "",
    sortOrder = "desc",
    dateFrom = "",
    dateTo = "",
    channel = ""
  ) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search }),
        ...(sortBy && { sort_by: sortBy }),
        ...(sortOrder && { sort_order: sortOrder }),
        ...(dateFrom && { date_from: dateFrom }),
        ...(dateTo && { date_to: dateTo }),
        ...(channel && { channel }),
      });

      const response = await axios.get(`${BASE_URL}/subscribers?${params}`, {
        headers: this.getHeaders(),
      });

      console.log("API Response:", response.data);

      return {
        status_code: response.data.data.status_code,
        data: response.data.data.data.data || [],
        pagination: {
          current_page:
            response.data.data.data.pagination?.current_page || page,
          total_pages: response.data.data.data.pagination?.total_pages || 1,
          total_items: response.data.data.data.pagination?.total || 0,
          items_per_page: response.data.data.data.pagination?.per_page || limit,
          has_next: response.data.data.data.pagination?.has_next || false,
          has_prev: response.data.data.data.pagination?.has_prev || false,
        },
        reason: response.data.data.reason,
      };
    } catch (error) {
      return {
        status_code: error.response?.data?.data?.status_code || "error",
        data: [],
        pagination: {
          current_page: page,
          total_pages: 1,
          total_items: 0,
          items_per_page: limit,
          has_next: false,
          has_prev: false,
        },
        reason:
          error.response?.data?.data?.reason || "Error fetching subscribers",
      };
    }
  }

  //* Method for bulk operations
  async bulkUpdateSubscribers(subscriberIds, action) {
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/subscribers/bulk-update`,
        {
          subscriber_ids: subscriberIds,
          action: action,
        },
        {
          headers: this.getHeaders(),
        }
      );

      return {
        status_code: response.data.data.status_code,
        reason: response.data.data.reason,
      };
    } catch (error) {
      return {
        status_code: error.response?.data?.data?.status_code || "error",
        reason:
          error.response?.data?.data?.reason ||
          "Error performing bulk operation",
      };
    }
  }

  //* Method for exporting subscribers
  async exportSubscribers(params = "") {
    try {
      const response = await axios.get(
        `${BASE_URL}/export_subscribers?${params}`,
        {
          headers: this.getHeaders(),
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `subscribers_export_${new Date().toISOString().split("T")[0]}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return {
        status_code: "000",
        message: "Export successful",
        data: response.data,
      };
    } catch (error) {
      console.error("Export error:", error);
      return {
        status_code: "error",
        message: "Export failed",
        data: null,
      };
    }
  }
}

const subscriberService = new SubscriberService();
export default subscriberService;
